export default "__VITE_ASSET__ClGJqnJo__"